(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('Provider_trDeleteController',Provider_trDeleteController);

    Provider_trDeleteController.$inject = ['$uibModalInstance', 'entity', 'Provider_tr'];

    function Provider_trDeleteController($uibModalInstance, entity, Provider_tr) {
        var vm = this;

        vm.provider_tr = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Provider_tr.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
